const pageRef = ref<HTMLElement | null>(null)

export default () => ({ pageRef })
